module.exports = __webpack_public_path__ + "static/img/oprCt_bg_07.08ec7ae6.svg";